import { Space } from 'antd';
import styled from 'styled-components';

export const SpaceStyled = styled(Space)`
  width: 100%;
  margin-top: 4rem;
`;
